<!--
frontend-author:bhavya, vaishnavi,
backend-author: bhavya,
page-name : invoice create.vue,
page-description : user role  create for invoice,
started at : 07-Juk-2019,
edited at :30-Dec-2019.
-->
<!-- Html code for user role create-->
<template>
  <div style="padding-bottom: 180px; margin-top: -10px">
    <!--  Header part for role page -->
    <GlobalHeader title="Create Role" v-if="page == 'create'" @redirectPage="redirectPage"></GlobalHeader>
    <GlobalHeader
      :title="'Update Role - ' + list.role_details.role_name"
      v-if="page == 'update'"
      @redirectPage="redirectPage"
    ></GlobalHeader>

    <!-- Form  -->
    <!-- Validation for invoice -->
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert
            class="alert-transparent alert-danger"
            :show="(error_show && this.errors.any()) || no_access"
          >
            <button
              type="button"
              @click="
                error_show = false;
                no_access = false;
              "
              class="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div v-for="item in errors.items" :key="item.id" v-if="item.scope == 'user-role-form'">
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
            <div v-if="no_access">
              <p class="fw-semi-bold">Give atleast one access for role.</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <b-form
      @submit.prevent="onSubmit('user-role-form')"
      id="userrole_form"
      data-vv-scope="user-role-form"
      class="pb-3 mt-3"
      style="margin-left: 3px; margin-right: 3px"
    >
      <b-form-group class="mb-1">
        <b-row style="max-width: 900px; font-family: sans-serif">
          <!--  Role Name -->
          <b-col xl="7" lg="7" md="6" sm="7" xs="7">
            <b-form-group
              horizontal
              :label="'Role Name'"
              label-class="required"
              label-breakpoint="md"
              label-for="basic"
            >
              <b-form-input
                type="text"
                size="sm"
                name="role_name"
                data-vv-name="role name"
                v-validate="'required|max:120'"
                v-model.trim="role_details.role_name"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form-group>

      <b-form-group class="mb-1">
        <b-row style="max-width: 900px; font-family: sans-serif">
          <!--  Description -->
          <b-col xl="7" lg="7" md="6" sm="7" xs="7">
            <b-form-group horizontal label="Description" label-for="description" breakpoint="md">
              <b-form-textarea
                data-vv-name="description"
                v-validate="'max:250'"
                v-model="role_details.role_desc"
                name="desc_notes"
                :rows="3"
                id="acl_notes"
                placeholder="Descriptions"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form-group>
      <div class="py-4">
        <b-row style="max-width: 1200px">
          <b-col class="md-6">
            <b-card header="CONTACTS" class="py-4">
              <!--  Contact part -->
              <table class="table table-resposive table-hover table-bordered">
                <thead class="text-center">
                  <th style="width: 23%"></th>
                  <th style="width: 12%">Full Access</th>
                  <th style="width: 12%">View</th>
                  <th style="width: 12%">Create</th>
                  <th style="width: 12%">Update</th>
                  <th style="width: 12%">Delete</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr>
                    <td>Customers</td>
                    <td
                      class="text-center"
                      v-for="(item, index) in actions"
                      :key="index"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'approve' &&
                        item != 'statement'
                      "
                    >
                      <b-form-checkbox
                        @change="pageassigning($event, 'customer', item)"
                        plain
                        v-model="customer[item]"
                      />
                    </td>
                    <td>
                      <b-dropdown
                        right
                        toggle-class="p-0 text-decoration-none"
                        menu-class="role-dropdown"
                        variant="link"
                        no-caret
                        size="xs"
                      >
                        <template slot="button-content">
                          <span class="text-primary">More Permissions</span>
                        </template>

                        <b-form-checkbox
                          @change="
                            pageassigning($event, 'customer', 'statement')
                          "
                          class="mx-3 role-check"
                          plain
                          v-model="customer.statement"
                        >Statement</b-form-checkbox>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card>

            <b-card header="PRODUCTS" class="py-4">
              <table class="table table-resposive table-hover table-bordered">
                <thead class="text-center">
                  <th style="width: 15%"></th>
                  <th style="width: 10%">Full Access</th>
                  <th style="width: 10%">View</th>
                  <th style="width: 10%">Create</th>
                  <th style="width: 10%">Update</th>
                  <th style="width: 10%">Delete</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Products</td>
                    <td
                      class="text-center"
                      v-for="(item, index) in actions"
                      :key="index"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'approve' &&
                        item != 'statement'
                      "
                    >
                      <b-form-checkbox
                        @change="pageassigning($event, 'product', item)"
                        plain
                        v-model="product[item]"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Product Bundle</td>
                    <td
                      class="text-center"
                      v-for="(item, index) in actions"
                      :key="index"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'approve' &&
                        item != 'statement'
                      "
                    >
                      <b-form-checkbox
                        :disabled="
                          !product.index &&
                          item != 'index' &&
                          item != 'update' &&
                          item != 'create'
                        "
                        @change="pageassigning($event, 'amcservice', item)"
                        plain
                        v-model="amcservice[item]"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Price Lists</td>
                    <td
                      class="text-center"
                      v-for="(item, index) in actions"
                      :key="index"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'approve' &&
                        item != 'statement'
                      "
                    >
                      <b-form-checkbox
                        :disabled="!product.index"
                        @change="pageassigning($event, 'pricelists', item)"
                        plain
                        v-model="pricelists[item]"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card>
            <b-card header="Banking" class="py-4">
              <!--  Contact part -->
              <table class="table table-resposive table-hover table-bordered">
                <thead class="text-center">
                  <th style="width: 23%"></th>
                  <th style="width: 12%">Full Access</th>
                  <th style="width: 12%">View</th>
                  <th style="width: 12%">Create</th>
                  <th style="width: 12%">Update</th>
                  <th style="width: 12%">Delete</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Banking</td>
                    <td
                      class="text-center"
                      v-for="(item, index) in actions"
                      :key="index"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'approve' &&
                        item != 'statement'
                      "
                    >
                      <b-form-checkbox
                        @change="pageassigning($event, 'banking', item)"
                        plain
                        v-model="banking[item]"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-card>
            <!--  Sales details -->
            <b-card header="SALES" class="py-4">
              <table class="table table-resposive table-hover table-bordered">
                <thead class="text-center">
                  <th style="width: 23%"></th>
                  <th style="width: 10%">Full Access</th>
                  <th style="width: 10%">View</th>
                  <th style="width: 10%">Create</th>
                  <th style="width: 10%">Update</th>

                  <th style="width: 10%">Delete</th>
                  <th style="width: 10%">Approve</th>

                  <th></th>
                </thead>
                <tbody>
                  <tr>
                    <td>Quotation</td>
                    <td
                      class="text-center"
                      v-for="(item, index) in actions"
                      :key="index"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'statement'
                      "
                    >
                      <b-form-checkbox
                        @change="pageassigning($event, 'quotation', item)"
                        plain
                        v-model="quotation[item]"
                        :disabled="
                          quotation.approvedaccess &&
                          item != 'full_access' &&
                          item != 'index' &&
                          item != 'approve' &&
                          item != 'create'
                        "
                      />
                    </td>
                    <td>
                      <b-dropdown
                        right
                        toggle-class="p-0 text-decoration-none"
                        menu-class="role-dropdown"
                        variant="link"
                        no-caret
                        size="xs"
                      >
                        <template slot="button-content">
                          <span class="text-primary">More Permissions</span>
                        </template>
                        <b-form-checkbox
                          class="mx-3 role-check mb-2"
                          @change="pageassigning($event, 'quotation', 'email')"
                          plain
                          v-model="quotation.email"
                        >Email</b-form-checkbox>
                        <b-form-checkbox
                          class="mx-3 role-check"
                          @change="
                            pageassigning($event, 'quotation', 'approvedaccess')
                          "
                          plain
                          v-model="quotation.approvedaccess"
                          :disabled="!quotation.approve"
                        >Edit and delete approved quotations</b-form-checkbox>
                      </b-dropdown>
                    </td>
                  </tr>
                  <tr>
                    <td>Invoice</td>
                    <td
                      class="text-center"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'statement'
                      "
                      v-for="(item, index) in actions"
                      :key="index"
                    >
                      <b-form-checkbox
                        @change="pageassigning($event, 'invoice', item)"
                        plain
                        v-model="invoice[item]"
                        :disabled="
                          invoice.approvedaccess &&
                          item != 'full_access' &&
                          item != 'index' &&
                          item != 'approve' &&
                          item != 'create'
                        "
                      />
                    </td>
                    <td>
                      <b-dropdown
                        right
                        toggle-class="p-0 text-decoration-none"
                        menu-class="role-dropdown"
                        variant="link"
                        no-caret
                        size="xs"
                      >
                        <template slot="button-content">
                          <span class="text-primary">More Permissions</span>
                        </template>

                        <b-form-checkbox
                          class="mx-3 role-check mb-2"
                          @change="pageassigning($event, 'invoice', 'email')"
                          plain
                          v-model="invoice.email"
                        >Email</b-form-checkbox>
                        <b-form-checkbox
                          class="mx-3 role-check mb-2"
                          @change="
                            pageassigning($event, 'invoice', 'cancelled')
                          "
                          plain
                          v-model="invoice.cancelled"
                        >Cancelled Invoices</b-form-checkbox>
                        <b-form-checkbox
                          class="mx-3 role-check mb-2"
                          @change="pageassigning($event, 'invoice', 'writeoff')"
                          plain
                          v-model="invoice.writeoff"
                        >Writeoff Invoices</b-form-checkbox>
                        <b-form-checkbox
                          class="mx-3 role-check"
                          @change="
                            pageassigning($event, 'invoice', 'approvedaccess')
                          "
                          plain
                          v-model="invoice.approvedaccess"
                          :disabled="!invoice.approve"
                        >Edit and delete approved invoices</b-form-checkbox>
                      </b-dropdown>
                    </td>
                  </tr>
                  <tr>
                    <td>Customer Payments</td>
                    <td
                      class="text-center"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'statement'
                      "
                      v-for="(item, index) in actions"
                      :key="index"
                    >
                      <b-form-checkbox
                        @change="
                          pageassigning($event, 'paymentsreceived', item)
                        "
                        plain
                        v-model="paymentsreceived[item]"
                        v-if="item != 'approve'"
                      />
                    </td>
                    <td>
                      <b-dropdown
                        right
                        toggle-class="p-0 text-decoration-none"
                        menu-class="role-dropdown"
                        variant="link"
                        no-caret
                        size="xs"
                      >
                        <template slot="button-content">
                          <span class="text-primary">More Permissions</span>
                        </template>
                        <b-form-checkbox
                          class="mx-3"
                          @change="
                            pageassigning($event, 'paymentsreceived', 'email')
                          "
                          plain
                          v-model="paymentsreceived.email"
                        >Email</b-form-checkbox>
                      </b-dropdown>
                    </td>
                  </tr>
                  <tr>
                    <td>Credit Note</td>
                    <td
                      class="text-center"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'statement'
                      "
                      v-for="(item, index) in actions"
                      :key="index"
                    >
                      <b-form-checkbox
                        @change="pageassigning($event, 'credit', item)"
                        plain
                        v-model="credit[item]"
                        v-if="item != 'approve'"
                      />
                    </td>
                    <td>
                      <b-dropdown
                        right
                        toggle-class="p-0 text-decoration-none"
                        menu-class="role-dropdown"
                        variant="link"
                        no-caret
                        size="xs"
                      >
                        <template slot="button-content">
                          <span class="text-primary">More Permissions</span>
                        </template>

                        <b-form-checkbox
                          class="mx-3 role-check mb-2"
                          @change="pageassigning($event, 'credit', 'email')"
                          plain
                          v-model="credit.email"
                        >Email</b-form-checkbox>
                        <b-form-checkbox
                          class="mx-3 role-check mb-2"
                          @change="pageassigning($event, 'credit', 'refund')"
                          plain
                          v-model="credit.refund"
                        >Refund</b-form-checkbox>
                        <!-- <b-form-checkbox
                          class="mx-3 role-check"
                          @change="
                            pageassigning($event, 'credit', 'approvedaccess')
                          "
                          plain
                          v-model="credit.approvedaccess"
                          :disabled="!credit.approve"
                        >
                          Edit and delete approved credit
                          notes
                        </b-form-checkbox> -->
                      </b-dropdown>
                    </td>
                  </tr>
                  <tr>
                    <td>Recurring Invoice</td>
                    <td
                      class="text-center"
                      v-for="(item, index) in actions"
                      :key="index"
                      v-if="
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'refund' &&
                        item != 'statement'
                      "
                    >
                      <b-form-checkbox
                        :disabled="!invoice.index"
                        @change="
                          pageassigning($event, 'recurringinvoice', item)
                        "
                        plain
                        v-model="recurringinvoice[item]"
                        v-if="item != 'approve'"
                      />
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Amc Contract</td>
                    <td
                      class="text-center"
                      v-for="(item, index) in actions"
                      :key="index"
                      v-if="
                        item != 'refund' &&
                        item != 'email' &&
                        item != 'approvedaccess' &&
                        item != 'writeoff' &&
                        item != 'cancelled' &&
                        item != 'statement'
                      "
                    >
                      <b-form-checkbox
                        v-if="item != 'approve'"
                        @change="pageassigning($event, 'amccontract', item)"
                        plain
                        v-model="amccontract[item]"
                      />
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-card>
            <b-card class="py-4">
              <template slot="header">
                <b-form-checkbox
                  @change="pageassigning($event, 'dashboard', 'full_access')"
                  plain
                  v-model="dashboard.full_access"
                >
                  <label class="form-check-label pl-2" style="padding-top: 2px">Dashboard</label>
                </b-form-checkbox>
              </template>
              <div
                class="card-body"
                style="
                  border: 1px solid rgba(0, 0, 0, 0.125) !important;
                  border-top: 0 !important;
                "
              >
                <table>
                  <tr>
                    <td style="border-top: 0 !important">
                      <b-form-checkbox
                        @change="
                          pageassigning(
                            $event,
                            'dashboard',
                            'total_receivables'
                          )
                        "
                        plain
                        v-model="dashboard.total_receivables"
                      >
                        <label
                          class="form-check-label pl-2"
                          style="padding-top: 2px"
                        >Total Receivables</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="pageassigning($event, 'dashboard', 'sales')"
                        plain
                        v-model="dashboard.sales"
                      >
                        <label class="form-check-label pl-2" style="padding-top: 2px">Sales</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="
                          pageassigning($event, 'dashboard', 'sales_rec_due')
                        "
                        plain
                        v-model="dashboard.sales_rec_due"
                      >
                        <label
                          class="form-check-label pl-2"
                          style="padding-top: 2px"
                        >Sales, Receipts and Dues</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                </table>
              </div>
            </b-card>

            <b-card class="py-4">
              <template slot="header">GST</template>
              <table class="table table-resposive table-hover table-bordered">
                <tr>
                  <td style="border-top: 0 !important">
                    <b-form-checkbox
                      :disabled="!reports.index"
                      @change="pageassigning($event, 'gstfiling', 'index')"
                      plain
                      v-model="gstfiling.index"
                    >
                      <label class="form-check-label pl-2" style="padding-top: 2px">GST Filing</label>
                    </b-form-checkbox>
                  </td>
                </tr>
              </table>
            </b-card>
            <b-card class="py-4">
              <template slot="header">
                <b-form-checkbox
                  @change="pageassigning($event, 'settings', 'full_access')"
                  plain
                  v-model="settings.full_access"
                >
                  <label class="form-check-label pl-2" style="padding-top: 2px">Settings</label>
                </b-form-checkbox>
              </template>
              <div
                class="card-body"
                style="
                  border: 1px solid rgba(0, 0, 0, 0.125) !important;
                  border-top: 0 !important;
                "
              >
                <table>
                  <tr>
                    <td style="border-top: 0 !important">
                      <b-form-checkbox
                        @change="pageassigning($event, 'settings', 'userrole')"
                        plain
                        v-model="settings.userrole"
                      >
                        <label class="form-check-label pl-2" style="padding-top: 2px">User Role</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="
                          pageassigning(
                            $event,
                            'settings',
                            'generalpreferences'
                          )
                        "
                        plain
                        v-model="settings.generalpreferences"
                      >
                        <label class="form-check-label pl-2" style="padding-top: 2px">Preferences</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="
                          pageassigning(
                            $event,
                            'settings',
                            'accounts'
                          )
                        "
                        plain
                        v-model="settings.accounts"
                      >
                        <label
                          class="form-check-label pl-2"
                          style="padding-top: 2px"
                        >Manage Accounts</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="
                          pageassigning($event, 'settings', 'openingbalance')
                        "
                        plain
                        v-model="settings.openingbalance"
                      >
                        <label
                          class="form-check-label pl-2"
                          style="padding-top: 2px"
                        >Opening Balances</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="pageassigning($event, 'settings', 'templates')"
                        plain
                        v-model="settings.templates"
                      >
                        <label class="form-check-label pl-2" style="padding-top: 2px">Templates</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="pageassigning($event, 'settings', 'export')"
                        plain
                        v-model="settings.export"
                      >
                        <label class="form-check-label pl-2" style="padding-top: 2px">Export Data</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="pageassigning($event, 'settings', 'taxes')"
                        plain
                        v-model="settings.taxes"
                      >
                        <label class="form-check-label pl-2" style="padding-top: 2px">Taxes</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="
                          pageassigning($event, 'settings', 'reportingtag')
                        "
                        plain
                        v-model="settings.reportingtag"
                      >
                        <label class="form-check-label pl-2" style="padding-top: 2px">Reporting tags</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="pageassigning($event, 'settings', 'email')"
                        plain
                        v-model="settings.email"
                      >
                        <label
                          class="form-check-label pl-2"
                          style="padding-top: 2px"
                        >Email Templates</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                </table>
              </div>
            </b-card>
            <b-card class="py-4">
              <template slot="header">
                <b-form-checkbox
                  @change="pageassigning($event, 'reports', 'full_access')"
                  plain
                  v-model="reports.full_access"
                >
                  <label class="form-check-label pl-2" style="padding-top: 2px">Reports</label>
                </b-form-checkbox>
              </template>
              <div
                class="card-body"
                style="
                  border: 1px solid rgba(0, 0, 0, 0.125) !important;
                  border-top: 0 !important;
                "
              >
                <table>
                  <tr>
                    <td style="border-top: 0 !important">
                      <b-form-checkbox
                        @change="
                          pageassigning($event, 'reports', 'salesreport')
                        "
                        plain
                        v-model="reports.salesreport"
                      >
                        <label class="form-check-label pl-2" style="padding-top: 2px">Sales</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-form-checkbox
                        @change="
                          pageassigning($event, 'reports', 'amccontractreport')
                        "
                        plain
                        v-model="reports.amccontractreport"
                      >
                        <label class="form-check-label pl-2" style="padding-top: 2px">AMC Contract</label>
                      </b-form-checkbox>
                    </td>
                  </tr>
                </table>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <div :class="{ unselectable: submitted }">
        <!-- footer block -->
        <div class="footer">
          <div :class="{ 'form-action': true, unselectable: submitted }">
            <b-button
              type="submit"
              variant="primary"
              class="btn-rounded mr-3"
              :disabled="submitted"
            >{{ page == "create" ? "Save" : "Update" }}</b-button>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>
<script>
// import all the components, files and funciton
import getPageTitle from "@/utils/get-page-title"; // to set page title
import { mapState } from "vuex"; // get data set in the state in vuex
import $ from "jquery"; // for using jquery function

export default {
  props: ["page", "submitted"],
  data() {
    return {
      error_show: false, // to show the error message
      actions: [
        "full_access",
        "index",
        "create",
        "update",
        "delete",
        "approve",
        "statement",
        "email",
        "refund",
        "approvedaccess",
        "writeoff",
        "cancelled"
      ],
      modules: [
        "reports",
        "gstfiling",
        "settings",
        "customer",
        "product",
        "amcservice",
        "pricelists",
        "quotation",
        "invoice",
        "paymentsreceived",
        "credit",
        "recurringinvoice",
        "amccontract",
        "dashboard"
      ],
      reports: {
        full_access: true,
        index: true,
        salesreport: true,
        amccontractreport: true
      },
      gstfiling: {
        index: true
      },
      settings: {
        full_access: true,
        userrole: true,
        generalpreferences: true,
        openingbalance: true,
        templates: true,
        taxes: true,
        reportingtag: true,
        email: true,
        export: true,
        accounts: true
      },
      customer: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true,
        statement: true
      },
      banking: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true
      },
      product: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true
      },
      amcservice: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true
      },
      pricelists: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true
      },
      quotation: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true,
        approve: true,
        email: true,
        approvedaccess: true
      },
      invoice: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true,
        approve: true,
        email: true,
        approvedaccess: true,
        writeoff: true,
        cancelled: true
      },
      paymentsreceived: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true,
        email: true
      },
      credit: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true,
        email: true,
        refund: true,
        // approve: true,
        // approvedaccess: true
      },

      recurringinvoice: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true
      },
      amccontract: {
        full_access: true,
        create: true,
        update: true,
        index: true,
        delete: true
      },
      dashboard: {
        index: true,
        full_access: true,
        total_receivables: true,
        sales: true,
        sales_rec_due: true
      },
      role_details: {
        role_name: "",
        role_desc: ""
      },
      no_access: false
    };
  },
  methods: {
    redirectPage() {
      this.$router.push({
        name: "UserRole"
      });
    },
    async pageassigning(ev, page, action) {
      this[page][action] = await ev;
      var success = 1;
      var pageindex = 0;

      if (action != "full_access") {
        if (ev == true) {
          this[page]["index"] = await ev;
          if (action == "delete") {
            this[page]["create"] = await ev;
            this[page]["update"] = await ev;
          } else if (action == "update") {
            this[page]["create"] = await ev;
          }
        } else {
          if (action == "index") {
            var field = this;
            await field.actions.map(function(value) {
              field[page][value] = ev;
            });
          } else if (action == "create") {
            this[page]["delete"] = await ev;
            this[page]["update"] = await ev;
          } else if (action == "update") {
            this[page]["delete"] = await ev;
          }
        }
        await $.each(this[page], Fieldkey => {
          if (this[page][Fieldkey] == true && Fieldkey != "index") {
            pageindex = 1;
          }
          if (Fieldkey != "full_access" && this[page][Fieldkey] == false) {
            success = 0;
          }
        });

        this[page]["full_access"] = await (success == 0 ? false : true);
        this[page]["index"] = await (pageindex == 1 ? true : true);
      } else {
        await $.each(this[page], Fieldkey => {
          this[page][Fieldkey] = ev;
        });
      }
      if (page == "reports") {
        if (action == "salesreport" || action == "amccontractreport") {
          this[page]["index"] = await (this[page].salesreport ||
          this[page].amccontractreport
            ? true
            : false);
        }
        if (
          page == "dashboard" ||
          action == "total_receivables" ||
          action == "sales" ||
          action == "sales_rec_due"
        ) {
          this[page]["index"] = await (this[page].total_receivables ||
          this[page].sales ||
          this[page].sales_rec_due
            ? true
            : false);
        }
        if (ev == false) {
          this.gstfiling["index"] = this[page]["index"];
        }
      }
      if (action == "approvedaccess" && ev == true) {
        this[page].update = ev;
        this[page].delete = ev;
      }
      if (action == "approve" && ev == false) {
        this[page].approvedaccess = ev;
      }
      if (
        page == "product" &&
        (action == "index" || action == "full_access") &&
        ev == false
      ) {
        this.amcservice.full_access = false;
        this.amcservice.delete = false;
        this.pageassigning(false, "pricelists", "full_access");
      }
      if (
        page == "invoice" &&
        (action == "index" || action == "full_access") &&
        ev == false
      ) {
        this.pageassigning(false, "recurringinvoice", "full_access");
      }
    },
    rolelist() {
      return {
        reports: this.reports,
        settings: this.settings,
        gstfiling: this.gstfiling,
        customer: this.customer,
        product: this.product,
        amcservice: this.amcservice,
        quotation: this.quotation,
        invoice: this.invoice,
        paymentsreceived: this.paymentsreceived,
        credit: this.credit,
        recurringinvoice: this.recurringinvoice,
        amccontract: this.amccontract,
        pricelists: this.pricelists,
        dashboard: this.dashboard,
        banking: this.banking
      };
    },
    async onSubmit(scope) {
      var check_arr = await [];
      for (var i = 0; i < this.modules.length; i++) {
        if (this.modules[i] == "settings") {
          for (const [key] of Object.entries(this.settings)) {
            await check_arr.push(this.settings[`${key}`]);
          }
        } else {
          await check_arr.push(this[this.modules[i]].index);
        }
      }
      this.no_access = await !check_arr.some(x => x == true);

      this.$validator.validateAll(scope).then(async result => {
        if (result && !this.no_access) {
          var field = await this.rolelist();
          //  send the json data
          var data = await JSON.stringify({
            field: field,
            role: this.role_details,
            app_id: process.env.VUE_APP_APP_ID
          });
          this.$emit("onSubmit", data);
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    },
    updateFields() {
      var field = this.rolelist();
      $.each(field, Fieldkey => {
        if (
          this.list.role_permission &&
          typeof this.list.role_permission[Fieldkey] != "undefined" &&
          this.list.role_permission[Fieldkey] != null
        ) {
          this[Fieldkey] = this.list.role_permission[Fieldkey];
        }
      });
      // this.field = this.list.role_permission; // assigning header value to the fiels datas
      this.role_details = this.list.role_details; // assigning header value to the fiels datas
    }
  },
  async created() {
    if (
      (this.$route.query.clone_id != "" &&
        typeof this.$route.query.clone_id != "undefined") ||
      this.page == "update"
    ) {
      document.title = getPageTitle(
        this.list.role_details.role_name + " | " + this.$route.meta.title
      );
      await this.updateFields();
    } else {
      this.update_price = true;
    }
    //  to watch any updates in details data
    await this.$watch(
      "field",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
    await this.$watch(
      "role_details",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.userrole.code,
      updated_id: state => state.userrole.updated_id,
      list: state => state.userrole.list
    })
  }
};
</script>

<style lang="scss" scoped>
.contacts {
  width: 1000px;

  font-size: 14px;
  border-radius: 0px;
}
.table-bordered th {
  background-color: #fff !important;
  border-top: 0px !important;
}
.table-bordered {
  border: 1px solid #d6dee5;
  border-top: 0px;
  margin-bottom: 0px;
  border-bottom: 0px;
}
.card-body {
  padding: 0;
  font-family: sans-serif;
  font-size: 13px;
}

.table th {
  font-weight: light;
}
.card {
  border: 0 !important;
  border-radius: 0px;
  font-family: sans-serif;
  font-size: 13px;
}
.table tbody td {
  font-family: sans-serif;
  font-size: 13px;
}
.card-header {
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
  border-radius: 0 !important;
}
</style>

